var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.name + (_vm.$route.params.id || '')}),_c('NotificationMessage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }